<template>
    <div class="pageClass VideoCourseHome ">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <NavBar></NavBar>
        <span style="">{{ErrorMsg}}</span>

        <!--div class="card-deck m-2">-->
        <div class="d-flex justify-content-cnter flex-wrap align-content-start CardGroup ">
            <div class="card m-2" v-for="(item,index) in CourseList">
                <div class="card-header">
                    <h5 class="m-0"><b>{{item.CourseName}}</b></h5>
                </div>
                <div class="g-progress" :style="[FilterHeight]" :id="'CardFilter'+index"></div>
                    <img class="card-img imgFilter" ref="CardImg" :src="item.ImageUri" @load="ImgClientHeight()">
                    <span class="cardSpan">{{ $t('videoCourseHome.progressRate') }}：{{(Math.round(item.ClassTime/item.TotalTime*100,0))>100?100:Math.round(item.ClassTime/item.TotalTime*100,0)}}%</span>
                <div class="card-body">
                    <span class="TimeSpac">{{ $t('videoCourseHome.totalTime') }}：{{TimeConvert(item.TotalTime)}} | {{ $t('videoCourseHome.totalTime') }}：{{TimeConvert(item.ClassTime)}}</span>
                </div>
                <div class="card-footer">
                    <div style="text-align:right;">
                        <button class="GOButton" @click="GoCourse(item)">{{ $t('videoCourseHome.goCourse') }}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'VideoCourseHome',
    components:{
        NavBar
    },
    data () {
        return {
            ErrorMsg:'',
            loginInputData:{
                Token :'',
                CustomerCode:'',
                StudentId:''
            },
            CourseList:[],
            showLoading:false,
            FilterHeight:{
                height:'0px'
            },
            // Token:'',
        }
    },
    mounted(){
        window.addEventListener('resize', this.ImgClientHeight);
        this.$nextTick(() => { 
            setTimeout(() => this.SetCardFilter(),800);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.ImgClientHeight);
    },

    methods:{
        TimeConvert(time){    
            var hour = 0;
            var min = 0;

            if(time < 3600){//小於1小時
                min = Math.trunc(time/60);
            }else{
                hour = Math.trunc(time/60/60);
                min = Math.trunc((time - hour*60*60)/60);
            } 
            return hour +  this.$t('videoCourseHome.hour') + min + this.$t('videoCourseHome.minute');
        },
        ImgClientHeight(){
            if(this.CourseList.length > 0){
                if(this.$refs.CardImg.length > 0){
                    this.FilterHeight.height = this.$refs.CardImg[0].clientHeight.toString() + 'px';
                } 
            }
        },
        //取得我的影片課程
        GetVideoClassByStudentId(){
            this.showLoading = true;
            const api =`${process.env.VIDEOAPIPATH}/api/Material/GetVideoClassByStudentId`;
            const headers = {"Authorization": 'Bearer '+this.loginInputData.Token};
            const inputdata = 
            {
                // "StudentId": 129611 ,
                "StudentId": this.loginInputData.StudentId ,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.IsSuccess){

                    }else{
                        this.ErrorMsg= this.$t('videoCourseHome.noLesson');
                    }
                    this.CourseList = response.data.CourseList;
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert(this.$t('videoCourseHome.getLessonError')+ error.message);
                });
        },
        SetCardFilter(){
            var progess = 0;

            this.CourseList.forEach((item,index) => {
                progess = Math.round(item.ClassTime/item.TotalTime*100,0);

                if(progess>100){
                    progess = 100;
                }
                // console.log(index,document.querySelector('#CardFilter'+index));
                document.querySelector('#CardFilter'+index).style.background = 
                    'conic-gradient(#ffffff00 0, #c0c0c031 ' + progess + '%, #6b6b6b9c ' + progess + '% , #6b6b6b9c)';
            });
        },
        //進入課程畫面
        GoCourse(item){
            this.$router.push({
                name: 'VideoClassPage',
                params: {
                    CourseItem: item,
                }
            });
        },
    },    
    created(){
        if(this.$route.query.UserKey != undefined){
            this.loginInputData = JSON.parse(window.atob(this.$route.query.UserKey.toString()));
            sessionStorage.setItem('Token',this.loginInputData.Token);
            sessionStorage.setItem('CustomerCode',this.loginInputData.CustomerCode);
            sessionStorage.setItem('StudentId',this.loginInputData.StudentId);
            sessionStorage.setItem('StudentUserId',this.loginInputData.StudentUserId);
            
            this.GetVideoClassByStudentId();
        }
        else{
            this.loginInputData.Token = sessionStorage.getItem('Token');
            this.loginInputData.StudentId = sessionStorage.getItem('StudentId');
            this.loginInputData.CustomerCode = sessionStorage.getItem('CustomerCode');
            this.GetVideoClassByStudentId();
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/VideoCourseHome.vue